import { ErrorState, Toaster, TooltipProvider } from "@repro/ui";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { ThemeContext } from "../components/theme-context";
import { ApiRequestError } from "../lib/api-client";
import { useTheme } from "../lib/theme";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: ({ error, reset }) => (
    <main className="flex min-h-dvh items-center justify-center">
      <ErrorState
        message={error instanceof Error ? error.message : undefined}
        requestId={error instanceof ApiRequestError ? error.requestId : undefined}
        onRetry={reset}
      />
    </main>
  ),
});

function Root() {
  const theme = useTheme();
  return (
    <ThemeContext.Provider value={theme}>
      <TooltipProvider delayDuration={300}>
        <Outlet />
        <Toaster theme={theme.theme} />
      </TooltipProvider>
    </ThemeContext.Provider>
  );
}

function NotFound() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-3 text-center">
      <p className="font-mono text-muted-foreground text-sm">404</p>
      <h1 className="font-semibold text-xl">This page does not exist</h1>
      <Link to="/" className="text-brand underline underline-offset-3">
        Go to your inbox
      </Link>
    </main>
  );
}
